module.exports = {
	// hostName: 'http://192.168.0.126:8081/',//郑炎成
	// hostName: 'http://192.168.0.59:8081/',//卞显壮
	// hostName: 'http://117.71.52.254:51197/',//测试
	// hostName: 'http://139.224.249.160/api/',//UAT测试 
	hostName: 'https://msslx.yakult.com.cn/api/',//正式
}
